var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#4868fd",
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z"
        }
      }),
      _c("g", { attrs: { fill: "#ffe252" } }, [
        _c("path", {
          attrs: {
            d:
              "M11.84 12.983s0-.046 0 0c-.091.046-.091.228 0 0zm8.045 6.766c-.091.046-.137.046 0 0zm-9.553-6.355-.046.046c.046.046.046.091.046-.046zm11.748 5.349.274.183a1.442 1.442 0 0 0-.274-.183z"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M8.777 17.143c.091-.046 0-.046 0-.091-.183.137-.046.091 0 .091zm13.211 1.554c.046.046 0 0 0 0zm-10.011-5.988a.705.705 0 0 0-.183.274c.046.274.183-.274.183-.274zm1.509 2.468h-.046c.046-.046.366-.046.183-.229-.229.046-.137.229-.412.229-.457.366.183 0 .274 0zm1.143-.503.091-.046s-.046 0-.091.046zm-1.691 1.966c.046-.046.046-.046 0 0zm-.367-1.143s-.046.046-.046.091c.046-.046.091-.046.046-.091zm4.206 5.394h.274c-.091-.046-.183 0-.274 0zm2.698-.639c-.046 0-.046 0-.091.046.091-.046.229-.137.32-.183l-.183.091c.046-.046.777-.32.366-.366-.869.549-2.24 1.189-.411.411zm-4.984-1.143c.046 0 .046-.046 0 0zm-.548-1.052s-.046.046-.046.091c.046-.046.137-.046.046-.091z"
          }
        }),
        _c("path", {
          attrs: {
            d:
              "M16.137 5.074c-6.08 0-11.063 4.937-11.063 11.017s4.937 11.063 11.063 11.063c6.08 0 11.017-4.937 11.017-11.063.046-6.08-4.891-11.017-11.017-11.017z"
          }
        })
      ]),
      _c("path", {
        attrs: {
          fill: "#02016f",
          d:
            "M10.423 17.783s.274.686.96 1.691c0 0-1.006.549-1.097.686-.229.091-.366.274-.594.366.549.412.777 1.052.777 1.052l1.691-1.097 2.423 1.28c-.137-.091-.046-.046.091 0-.091-.091 1.417.366.914.183 1.829.137 5.211-.411 6.583-2.697-.046.091.137-.183.046-.091.137-.32.777-.229.046-.549.091.091.457.366.229.229-.868-.777-1.188-.183-1.828.503-.229.046.777-1.052.32-.457.503-.274.091-1.097.869-.594-.137-.183-.046-.046-.32-.274 0-.091-.549.64-.32.457-.274.229-.32.274-.503.503.32-.137-.64.777-.457.411-.137.137-.731.503-.777.503-.32.229-.64.32-1.006.457.046-.046-.229.046-.229.046h.229c-1.143.366-3.566.046-3.977-.366-1.508-.686.183-.731.183-1.143.549-.091.594-.503 1.006-.503.137-.229.686-.366.914-.594.229-.183.731-.503 1.143-.64-.137-.091.229-.137.32-.32-.091.046-.183-.091 0-.137-.366-1.28-1.143-.366-1.874 0-.046.091-.183-.183-.32 0 .366-.046-.366.503-.549.503-.137.137.046-.32.183-.183.091-.091.183-.274.091-.274.091.046-.183.137-.091.137-.137 0-.183 0-.274.091.183.046-.32.32-.183.137l-1.966 1.234c-.411.411-.64-.137-.823-.274-.046-.137-.549-.869-.274-.686-.457-.823 1.371-.594 1.143-1.006.549 0 .64-.411 1.051-.32.137-.183.732-.274.96-.457.229-.137.823-.411 1.234-.457-.091-.137.274-.091.32-.274-.091 0-.137-.137.046-.137-.183-1.326-1.097-.549-1.828-.274-.046.137-.183-.229-.32-.046.366 0-.457.412-.594.412-.183.091.091-.274.183-.183.091-.091.229-.229.137-.229.091.046-.229.091-.091.137-.137-.046-.183-.046-.274.046.183.046-.366.274-.229.091l-2.149.96c-.32-.091-.046-1.417.046-1.463.091-.366.229-.914.229-.686.046-.366.183-1.006.183-.731.274-.503.503-.869.869-1.234.823-.96 1.737-1.097 3.109-1.463.549-.137 1.737-.137 1.737-.137s.229-.64.137-1.326c-1.28-.137-2.194 0-3.337.32-.594.229-1.28.503-1.6.96.32-.229.092 0 .137.046-1.28.32-2.56 2.926-2.606 3.017 0 .137-.046.32-.137.549v-.046c0 .137-.046.091-.046.046-.091.274-.183.503-.046.457-.274.686-.229 1.646-.091 2.331.32.183-1.189.594-1.28.594-.091-.091-.229.366-.229.183-.229.046-.411.229-.64.274.457.457.686 1.143.686 1.143.64-.457 1.737-.686 1.737-.686zm9.463 1.966c-.091.046-.137.046 0 0zm0 .046c.411.046-.32.32-.366.366l.183-.091c-.046.046-.183.183-.32.183 0 0 .046 0 .091-.046-1.829.823-.457.183.411-.411zm-5.029-2.514c-.046 0-.046 0 0 0zm-1.28-2.423c-.046 0-.046 0 0 0zm-.366.274c.229.046.183-.183.412-.229.183.183-.137.183-.183.229h.046c-.091.046-.731.411-.274 0zm-4.434 1.92c0 .046.091.046 0 .091-.046 0-.183.046 0-.091z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }